import { render, staticRenderFns } from "./doc-view.vue?vue&type=template&id=4182d77b&scoped=true"
import script from "./doc-view.vue?vue&type=script&lang=js"
export * from "./doc-view.vue?vue&type=script&lang=js"
import style0 from "./doc-view.vue?vue&type=style&index=0&id=4182d77b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4182d77b",
  null
  
)

export default component.exports